import { useGlobalState } from '../../Contexts/globalStateContext';

export const useLegacy = (legacy?: boolean) => {
	const {
		state: { legacy: stateLegacy },
	} = useGlobalState();
	return legacy !== undefined ? legacy : stateLegacy;
};
